<template>
    <div class="review">
        <div class="review-content animated slideInUp">
            <h1>Let's Review</h1>
            
            <ul>
                <h2>ORC</h2>
                <li>The ORC department is responsible for investigating organized retail crime to prevent future shrink from fence operations.</li>
            </ul>

            <ul>
                <h2>Reporting</h2>
                <li>AP Investigations relies on intel from the store level to identify and investigate ORC operations.</li>
            </ul>
            
            <ul>
                <h2>Booster Interviews</h2>
                <li>When interviewing a potential suspect, it’s vital <br />to get to the point efficiently and avoid common <br /> mistakes that could derail the investigation <br />and distract from the bigger picture.</li>
            </ul>
        </div>
        
        <ExitButton @click.native.stop="saveScore" :disabled="this.disabled" />
    </div>
</template>

<script>
import ExitButton from '@/components/ExitButton.vue'

export default {
  components: {
    ExitButton
  },
  data() {
      return {
          disabled: false
      }
  },
  methods: {
      saveScore() {
        const name = this.$store.state.name
        const score = this.$store.state.score

        if(score > 0) {
            const api = 'https://6emcgv6qw5.execute-api.us-east-1.amazonaws.com/dev/'
            this.$http.post(api, { name: name, score: score }).then(() => {
                this.$store.dispatch('resetStore')
                this.$router.push('/login')
            })
        } else {
            this.$store.dispatch('resetStore')
            this.$router.push('/login')
        }
      }
  },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>
.review {
    background: url("~@/assets/roadblock-bg.jpg") center center no-repeat;
    background-size: cover;
    height: 100%;
    width: 100%;
}

.review-content {
    text-align: left;
    background: url("~@/assets/review-modal.svg") center center no-repeat;
    background-size: cover;
    width: 620px;
    height: 370px;
    position: absolute;
    top: 3px;
    left: 25px;
}

h1 { 
    color: #fff;
    padding: 45px 0 0 200px;
    font-size: 35px;
}

h2 {
    color: #F98B02;
    display: table-cell;
    font-family: 'Arvo', serif;
    width: 110px;
    font-size: 18px;
}
li {
    color: #4A4A4A;
    padding: 0 50px 0 20px;
    font-size: 17px; 
    display: table-cell;
    line-height: 19px;
}
</style>
